// Orchard can packs: Single $4.99 + 4-pack $18.99 (2026-09-06 Jeff GO)
(function () {
  var P = window.PROD;
  if (!P) return;
  var packs = [
    { l: "Single", p: 4.99 },
    { l: "4-pack", p: 18.99, tag: "most popular" }
  ];
  var vars = {"pineapple": ["45998659076130", "44279016161314"], "raspberry": ["45998649704482", "44279010230306"], "tangerine": ["45998659305506", "44279012655138"], "cherry": ["45998659174434", "44279013539874"]};
  ["pineapple", "tangerine", "cherry", "raspberry"].forEach(function (k) {
    if (!P[k] || P[k].kind !== "can") return;
    P[k].packs = packs;
    P[k].vars = vars[k];
  });
})();
